module.exports = __webpack_public_path__ + "workspace/static/img/announcement-512.99294cf.png";